import { useState } from 'react';
import './FeedbackModal.scss';
import { Button, Form, TextArea } from 'semantic-ui-react';
import emailjs from 'emailjs-com';
import cn from 'classnames';
import CloseIcon from '../CloseIcon/CloseIcon.jsx';
import Modal from '../Modal/Modal.jsx';

const FeedbackModal = ({ open, closeModal }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const sendEmail = (e) => {
    e.preventDefault();

    setLoading(true);

    emailjs
      .sendForm(
        'service_7iemzwu',
        'template_4su7ua2',
        e.target,
        'user_r29kIEi0kyfZnb0Bcp4oc'
      )
      .then(
        () => {
          setLoading(false);
          closeModal();
        },
        () => {
          setLoading(false);
          closeModal();
        }
      );
  };

  return open ? (
    <Modal width={500}>
      <Form onSubmit={sendEmail}>
        Email
        <Form.Input
          type="email"
          name="email"
          placeholder="(必填)"
          onChange={(e) => setEmail(e.target.value.trim())}
        />
        請於下方輸入，並按下送出
        <TextArea
          name="message"
          placeholder="..."
          onChange={(e) => setMessage(e.target.value.trim())}
          className="text-area"
        />
        <Button
          className={cn({
            loading,
            disabled: !email || !validateEmail(email) || message === '',
          })}
          disabled={!email || !validateEmail(email) || message === ''}
        >
          送出
        </Button>
      </Form>
      <CloseIcon close={closeModal} />
    </Modal>
  ) : null;
};

export default FeedbackModal;
